export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  LOGIN_OTP: "/login_otp",
  HOME: "/home",
  APP_INITIALIZER: "/appInitializer",
  // Stage 1
  EMAIL_VERIFICATION: "/email_verification",
  PERSONAL_DETAILS: "/personal_details",
  PAN_CHECK_PENDING: "/pan_check_pending",
  PAN_CHECK_FAILED: "/pan_check_failed",
  ON_HOLD: "/on_hold",
  INCOME_INFO: "/income_details",
  ADDRESS_DETAILS: "/address_details",
  ELIGIBILITY_CHECK_PENDING: "/eligibility_check_pending",
  ELIGIBILITY_CHECK_FAILED: "/eligibility_check_failed",
  ELIGIBILITY_CHECK_MANUAL: "/eligibility_check_manual",
  DOWNLOAD_APP: "/download_app",
};
